import { Button, Card } from "react-bootstrap";

import { convertCamelCaseToTitle } from "../../utils";
import { OfferingUserList } from "../";
import { BlockInput } from "../blockInput";

export const OfferingUsers = ({
	entity,
	users = null,
	addUser,
	removeUser,
	isLoading,
}) => (
	<Card className="mb-4 offeringUserCard" data-testid="test-offeringUserCard">
		<BlockInput blocking={isLoading} />
		<Card.Header className="p-2 ps-3">
			<span className="mt-1">{convertCamelCaseToTitle(entity)}</span>
			<Button
				size="sm"
				className="p-1 float-end"
				onClick={() => addUser(entity)}
			>
				Add
			</Button>
		</Card.Header>
		<Card.Body className="p-0">
			<OfferingUserList
				removeUser={removeUser}
				users={users}
				entity={entity}
			/>
		</Card.Body>
	</Card>
);
